exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-date-picker {\n.mx-input {\n    padding: 0 10px !important;\n}\n}\n.mx-datepicker {\n  width: 100%;\n  display: block;\n.mx-input {\n    box-shadow: none;\n    border: none;\n    display: block;\n    padding: 0;\n    background: none;\n    color: #000;\n    font-size: 16px;\n    height: 26px;\n}\n}\n", ""]);

// exports
